import {
  AppBar,
  Box,
  Button,
  Grid,
  TablePagination,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import React, { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenGrid from '../../../../global_components/KenGrid';
import KenPopover from '../../../../Components/KenPopOver';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import { RiFilterLine, RiCheckFill, RiFileDownloadLine } from 'react-icons/ri';
import Kentable from '../../../../global_components/KenTable/kentable';
import { Message } from '@material-ui/icons';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import KenSelect from '../../../../global_components/KenSelect';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import KenLoader from '../../../../Components/KenLoader/index';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import KenGridEditable from '../../../../global_components/kenEditDataGrid/kenGridEditable';
import KenEditablePdf from '../../../../global_components/kenEditDataGrid/KenEditablePdf';

import validator from 'validator';
// import '../../../../style/index.css';
import {
  getExamModuleListData,
  getSeatingPlanData,
  postSeatingPlanData,
  publishExam,
} from '../../../../Utils/apiServices';
import { sendMailSeatingPlan } from '../../../../Utils/sendMail';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TablePaginationActions from '../../../../global_components/KenGrid/TablePaginationActions';
import SamplePdf from '../../../../Assets/samplePdf.pdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTranslation } from 'react-i18next';
import RetestExam from './RetestExam';

import Pdf from 'react-to-pdf';

const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'SEATING PLAN',
  },
];
export const timeDuration = [
  {
    label: '30',
    value: '30',
  },
  {
    label: '60',
    value: '60',
  },
  {
    label: '90',
    value: '90',
  },
  {
    label: '120',
    value: '120',
  },
  {
    label: '150',
    value: '150',
  },
  {
    label: '180',
    value: 180,
  },
  {
    label: '210',
    value: '210',
  },
  {
    label: '240',
    value: '240',
  },
  {
    label: '270',
    value: '270',
  },
  {
    label: '300',
    value: '300',
  },
];
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    height: '28px',
    minWidth: '78px',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: 'orange',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: 'white',
    margin: '5px',
    fontSize: '12px',
    background: '#55b0cd',
    borderRadius: '10px',
    padding: '7px',
    width: '100px',
    height: '35px',
    '&:hover': {
      background: '#55b0cd',
      color: 'white',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishGenerate: {
    // color: '#505F79',
    color: 'white !important',
    width: '100px',
    height: '35px',
    background: 'green',
    // background: '#27AE60',

    // background: '#505F79',

    borderRadius: '10px',
    fontSize: '12px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: 'green',

      color: 'white !important',
      // border: '1px solid white',
    },
    // color: '#FFFFFF',
    // background: '#979797',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsProgram = [
  {
    label: 'Select Batch',
    value: '--Select--',
  },
  {
    label: 'Batch 1',
    value: '1',
  },
  {
    label: 'Batch 2',
    value: '2',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Date',
    value: '--Select--',
  },
  {
    label: 'Date 1',
    value: '1',
  },
  {
    label: 'Date 2',
    value: '2',
  },
];

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'February',
    value: 'February',
  },
  {
    label: 'April',
    value: 'April',
  },
  {
    label: 'October',
    value: 'October',
  },
  {
    label: 'December',
    value: 'December',
  },
];

const filterOptions = (data, type) => {
  switch (type) {
    case 'course':
      let courseOP = [
        {
          label: 'Select Course',
          value: '--Select--',
        },
      ];
      const uniqueCourseOP = [...new Set(data.map((item) => item?.course))];
      uniqueCourseOP.forEach((el) => courseOP.push({ label: el, value: el }));
      return courseOP;
    case 'term':
      let termOP = [
        {
          label: 'Select Term',
          value: '--Select--',
        },
      ];
      const uniqueTermOP = [...new Set(data.map((item) => item?.term))];
      uniqueTermOP.forEach((el) => termOP.push({ label: el, value: el }));
      return termOP;
    case 'duration':
      let durationOP = [
        {
          label: 'Select Duration',
          value: '--Select--',
        },
      ];
      const uniqueDurationOP = [...new Set(data.map((item) => item?.duration))];
      uniqueDurationOP.forEach((el) =>
        durationOP.push({ label: el, value: el })
      );
      return durationOP;
    case 'exam':
      let examTypeOP = [
        {
          label: 'Select Exam Type',
          value: '--Select--',
        },
      ];
      const uniqueExamTypeOP = [
        ...new Set(data.map((item) => item?.exam_type)),
      ];
      uniqueExamTypeOP.forEach((el) =>
        examTypeOP.push({ label: el, value: el })
      );
      return examTypeOP;
    default:
      break;
  }
};

const selectOptionsDuration = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: '6',
    value: '6',
  },
  {
    label: '7',
    value: '7',
  },
  {
    label: '8',
    value: '8',
  },
  {
    label: '9',
    value: '9',
  },
  {
    label: '10',
    value: '10',
  },
  {
    label: '11',
    value: '11',
  },
  {
    label: '12',
    value: '12',
  },
];

const selectOptionsExamType = [
  {
    label: 'Ofline',
    value: 'Ofline',
  },
  {
    label: 'Online',
    value: 'Online',
  },
];
const ref = React.createRef();
const options = {
  orientation: 'landscape',
  unit: 'in',
  format: [12.2, 12],
};
const SeatingPlan = () => {
  const [rows, setRows] = useState([]);
  const { t } = useTranslation();
  const [rowsData, setrowsData] = useState([]);

  const [previous, setPrevious] = useState({});
  const [showPdf, setShowPdf] = useState(false);

  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  // filter options
  const [courseOptions, setCourseOptions] = useState('');
  const [termOptions, setTermOptions] = useState('');
  const [durationOptions, setDurationOptions] = useState('');
  const [examTypeOptions, setExamTypeOptions] = useState('');
  //
  const [selectedDuration, setSelectedDuration] = useState('');
  const [loading, setLoading] = useState(false);
  const [publishData, setPublishData] = useState(null);

  //Pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // FIlter States
  const [filterIData, setFilterIData] = useState();

  const [selectCourseData, setselectCourseData] = useState([]);
  const [selectTermData, setselectTermData] = useState([]);
  const [selectCampusData, setselectCampusData] = useState([]);

  const [selectFacultyData, setselectFacultyData] = useState([]);

  /* email send funcion */
  useEffect(() => {
    if (publishData !== null) {
      console.log('publishData', publishData?.id);
      sendMailSeatingPlan(publishData?.id);
    }
  }, [publishData]);
  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedTerm, setSelectedTerm] = useState('');

  const [selectValueTerm, setSelectValueTerm] = useState(
    selectOptionsTerm[0].value
  );
  const [selectedExamType, setSelectedExamType] = useState(
    selectOptionsBatch[0].value
  );
  const handleCourseChange = (e) => {
    setSelectedCourse(e.target.value);
  };

  const handleTermChange = (e) => {
    setSelectedTerm(e.target.value);
    setSelectedCourse('');
  };

  const handleExamTypeChange = (e) => {
    setSelectedExamType(e.target.value);
  };

  const handleDurationChange = (e) => {
    setSelectedDuration(e.target.value);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [filterDialog, setFilterDialog] = useState(false);
  const [retestExamDialog, setRetestExamDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  function handleRetestExamDialog() {
    setRetestExamDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  function handleSendBulkMessageDialogNo() {
    toast.info('Mail has send successfully without hall ticket', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setSendBulkMessageDialog(false);
  }

  function handleSendBulkMessageDialogYes() {
    toast.success('Mail has send successfully with hall ticket', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setSendBulkMessageDialog(false);
  }

  const [selectValueBatch1, setSelectValueBatch1] = useState([]);
  const [selectValueBatch, setSelectValueBatch] = useState('');
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };
  const [selectValueExamCycle1, setSelectValueExamCycle1] = useState([]);

  const [selectValueExamCycle, setSelectValueExamCycle] = useState('');
  const handleSelectChangeExamCycle = (e) => {
    setSelectValueExamCycle(e.target.value);
  };

  const onPublishData = (id) => {
    const payLoad = [
      {
        id: id,
        sendEmail: true,
        body: 'Type Email Body Here',
        subject: 'Type Email Subject Here',
      },
    ];
    publishExam(payLoad)
      .then((res) => {})
      .catch(() => {});
  };

  // Editing
  // const [dataOfTable, setDataOfTable] = useState(data);

  const [pageNumber, setPageNumber] = useState();
  const getSeatingDatas = () => {
    setLoading(true);
    let filterData = {
      pageNo: page,
      count: rowsPerPage,
      course: selectedCourse,
      duration: selectedDuration,
      termName: selectedTerm,
      examType: selectedExamType,
      batch: selectValueBatch,
      examCycle: selectValueExamCycle,
    };
    getSeatingPlanData(filterData)
      .then((res) => {
        console.log('resresresresres', res);
        setLoading(false);
        const SeatingInfo =
          res.timeTableList === null
            ? []
            : res.timeTableList.map((item, index) => {
                return {
                  id: item.id,
                  course: item.course ? item.course : 'NA',
                  term: item.termName ? item.termName : 'NA',
                  candidates: item.numberOfCandidates
                    ? item.numberOfCandidates
                    : 'NA',
                  date: item.dateOfExam ? item.dateOfExam : 'NA',
                  start_time: item.startTimeOfExam
                    ? item.startTimeOfExam
                    : 'NA',
                  duration: item.duration ? item.duration : 'NA',
                  exam_type: item.examType ? item.examType : 'NA',
                  batch: item.batch ? item.batch : '',
                  examTimeZone: item.examTimeZone ? item.examTimeZone : '',
                  campus: item.campus ? item.campus : '',
                  studentFacultyRatio: item.studentFacultyRatio
                    ? item.studentFacultyRatio
                    : '',
                  examCycle: item.examCycle ? item.examCycle : '',
                  venue: item.venue ? item.venue : '',
                  eligibleStudents: item.totalEligibleStudents
                    ? item.totalEligibleStudents
                    : 0,

                  generateStatus: item.generateStatus
                    ? item.generateStatus
                    : false,
                };
              });

        setRows(SeatingInfo);
        setrowsData(SeatingInfo);
        setFilterDialog(false);
        setPageNumber(res.noOfRecords);
      })
      .catch((err) => {
        console.log('Seating Plan Data=>', err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getSeatingDatas();
  }, [page, rowsPerPage]);
  useEffect(() => {
    if (rows.length > 0 || !null) {
      setCourseOptions(filterOptions(rows, 'course'));
      setTermOptions(filterOptions(rows, 'term'));
      setDurationOptions(filterOptions(rows, 'duration'));
      setExamTypeOptions(filterOptions(rows, 'exam'));
    }
  }, [rows]);

  const getFilterData = (filter) => {
    const newData = [];
    const users = rowsData.filter((item) => {
      for (let key in filter) {
        if (item[key] === undefined || item[key] != filter[key]) {
          return item;
        }
      }
    });
    //Term
    rows.map((item) => {
      if (item.term === selectedTerm) {
        newData.push(item);
      }
    });
    // course
    rows.map((item) => {
      if (item.course === selectedCourse) {
        newData.push(item);
      }
    });
    //Duration
    rows.map((item) => {
      if (item.duration === selectedDuration) {
        newData.push(item);
      }
    });
    //ExamType
    rows.map((item) => {
      if (item.exam_type === selectedExamType) {
        newData.push(item);
      }
    });

    setRows(newData);
  };

  useEffect(() => {
    getExamModuleListData().then((res) => {
      setFilterIData(res);
    });
  }, []);

  useEffect(() => {
    let TermListData = filterIData?.TermList.map((item) => {
      return {
        label: item.TermName,
        value: item.TermName,
      };
    });
    setselectTermData(TermListData);

    // For Course
    let CourseListData = filterIData?.CourseList.filter((item) => {
      return selectedTerm == item.TermName && item.TermName && item.CourseName;
    }).map((item) => {
      return {
        label: item.CourseName,
        value: item.CourseName,
      };
    });

    setselectCourseData(CourseListData);

    // For Faculty
    let FacultyListData = filterIData?.courseFacultyList
      .filter((item) => {
        console.log('item---Fac', item);
        return selectedTerm === item.CourseName;
      })
      .map((itemss) => {
        let Fcaulty = itemss?.FacultyName?.map((item) => {
          return {
            label: item,
            value: item,
          };
        });
        setselectFacultyData(Fcaulty);
      });

    //For Campus
    let CampusListData = filterIData?.campus.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setselectCampusData(CampusListData);

    let BatchListData = filterIData?.batchList
      .filter((item) => {
        return item != null;
      })
      .map((item) => {
        return {
          label: item,
          value: item,
        };
      });
    setSelectValueBatch1(BatchListData);

    let ExamCycleListData = filterIData?.ExamMonthList.filter((item) => {
      return item != null;
    }).map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setSelectValueExamCycle1(ExamCycleListData);
  }, [filterIData, selectValueTerm, selectedTerm]);

  useEffect(() => {
    getFilterData();
  }, [page, rowsPerPage]);
  const handleResetFilter = () => {
    setFilterDialog((prevState) => !prevState);
    setRows(rowsData);
  };
  return (
    <Box>
      {loading && <KenLoader />}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />{' '}
      {/* test */}
      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Exam Timetable & Seating Plan
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {/* <Button
              startIcon={<GetAppIcon />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
            >
              <a
                href={SamplePdf}
                style={{ textDecoration: 'none', color: 'white' }}
                download
              >
                {t('labels:Report')}
              </a>
            </Button>{' '} */}
            <Pdf
              targetRef={ref}
              filename="EXAM_TIMETABLE_SEATING_PLAN.pdf"
              options={options}
              x={0}
              y={0}
              onComplete={() => {
                setShowPdf(false);
              }}
              // scale={0.8}
            >
              {({ toPdf }) => (
                <Button
                  startIcon={<RiFileDownloadLine />}
                  variant="contained"
                  color="primary"
                  style={{ marginRight: '15px' }}
                  className={classes.addButton}
                  onClick={() => {
                    setShowPdf(true);
                    toPdf();
                  }}
                >
                  Download Pdf
                </Button>
              )}
            </Pdf>{' '}
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleRetestExamDialog}
            >
              Retest Exam
            </Button>
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead className={classes.tableHaderTitle}>
              <TableRow style={{ background: '#FFFFFF' }}>
                <TableCell
                  style={{
                    fontWeight: '500',
                    color: '#193389',
                    padding: '7px',
                    background: '#FFFFFF',
                  }}
                  align="left"
                >
                  COURSE
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: '500',
                    color: '#193389',
                    padding: '7px',
                    background: '#FFFFFF',
                  }}
                  align="left"
                >
                  TERM
                </TableCell>{' '}
                <TableCell
                  style={{
                    fontWeight: '500',
                    color: '#193389',
                    padding: '7px',
                    background: '#FFFFFF',
                  }}
                  align="left"
                >
                  CAMPUS
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: '500',
                    color: '#193389',
                    padding: '7px',
                    background: '#FFFFFF',
                  }}
                  align="left"
                >
                  EXAM CYCLE
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: '500',
                    color: '#193389',
                    padding: '7px',
                    background: '#FFFFFF',
                  }}
                  align="left"
                >
                  BATCH
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: '500',
                    color: '#193389',
                    padding: '7px',
                    background: '#FFFFFF',
                  }}
                  align="center"
                >
                  SEATING PLAN
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => {
                let venueLink;
                /* if (validate(row.venue_link)) {
                  venueLink = 'kenInput';
                } else if (row.venue_link == 'Generate') {
                  venueLink = 'kenSelect';
                } */
                return (
                  <TableRow className="editableTableRowData" key={row.id}>
                    <KenGridEditable
                      {...{
                        row,
                        onChange,
                        columns: [
                          {
                            column_name: 'course',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },
                          {
                            column_name: 'term',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },
                          {
                            column_name: 'campus',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },
                          {
                            column_name: 'examCycle',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },
                          {
                            column_name: 'batch',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },

                          // {
                          //   column_name: 'eligibleStudents',
                          //   is_inline_edit: false,
                          //   inline_edit_type: '',
                          // },

                          /* {
                            column_name: 'venue_link',
                            is_inline_edit: true,
                            inline_edit_type: venueLink,
                          }, */
                        ],
                      }}
                    />

                    <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex' }}>
                          <Button
                            variant="primary"
                            className={classes.normal}
                            // to={`${routes.seatingPlan}/arrangement/${row.eligibleStudents}/${row.id}`}
                          >
                            {console.log('row.idrow.idrow.id', row)}
                            <Link
                              className={classes.normal}
                              to={{
                                pathname: `${routes.seatingPlan}/arrangement/${row.id}`,
                                state: { data: row },
                              }}
                            >
                              Generate
                            </Link>
                          </Button>

                          <Button
                            variant="primary"
                            component={Link}
                            className={classes.normal}
                            to={`${routes.seatingPlan}/${row.id}`}
                          >
                            Details
                          </Button>

                          {row.generateStatus === 'True' ? (
                            <Button
                              variant="primary"
                              // component={Link}
                              className={classes.publishGenerate}
                              onClick={() => {
                                onPublishData(row.id);
                              }}
                            >
                              SEND
                            </Button>
                          ) : (
                            <Button
                              variant="primary"
                              disabled={true}
                              // component={Link}
                              className={classes.publishGenerate}
                              // onClick={() => {
                              //   onPublishData(row.id);
                              // }}
                            >
                              SEND
                            </Button>
                          )}
                        </div>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              colSpan={6}
              count={rows ? pageNumber : rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />{' '}
          </Table>
        </KenCard>
      </Box>{' '}
      <Box style={{ height: '100%' }} ref={ref} className={`cardlsitbox`}>
        {showPdf && (
          <KenCard elevation={0}>
            <Table className={classes.table} aria-label="caption table">
              <TableHead className={classes.tableHaderTitle}>
                <TableRow>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    COURSE
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    TERM
                  </TableCell>{' '}
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    CAMPUS
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    EXAM CYCLE
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    BATCH
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    DATE
                  </TableCell>{' '}
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    START TIME (IST)
                  </TableCell>{' '}
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    TIME ZONE
                  </TableCell>{' '}
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    DURATION
                  </TableCell>{' '}
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    EXAM TYPE
                  </TableCell>{' '}
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      border: '1px solid #000',
                    }}
                    align="left"
                  >
                    EXAM MODE
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ border: '1px solid #000' }}>
                {rows.map((row, index) => {
                  let venueLink;
                  return (
                    <TableRow
                      style={{ border: '1px solid #000' }}
                      className="editableTableRowData"
                      key={row.id}
                    >
                      <KenEditablePdf
                        {...{
                          row,
                          onChange,
                          columns: [
                            {
                              column_name: 'course',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'term',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'campus',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'examCycle',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'batch',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'date',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'start_time',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'examTimeZone',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'duration',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'exam_type',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                            {
                              column_name: 'exam_type',
                              is_inline_edit: false,
                              inline_edit_type: '',
                            },
                          ],
                        }}
                      />
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </KenCard>
        )}
      </Box>
      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        icon={<RiCheckFill />}
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleResetFilter()}
        positiveButtonClick={() => getSeatingDatas()}
        positiveButtonText="Apply"
        negativeButtonText="Clear"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={selectTermData}
              value={selectedTerm}
              defaultValue={() => {
                return termOptions[0].value;
              }}
              dropdownColor="#FFFFFF"
              onChange={handleTermChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectCourseData}
              value={selectedCourse}
              defaultValue={() => {
                return courseOptions[0].value;
              }}
              dropdownColor="#FFFFFF"
              onChange={handleCourseChange}
              required
            />
          </Grid>

          {/* <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectOptionsProgram}
              value={selectValueProgram}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid> */}
          {/*   <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Start Date"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Start Date"
              value={endDate}
              type="date"
              required={true}
              defaultValue={endDate}
              onChange={manageStartDate}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Duration"
              options={selectOptionsDuration}
              value={selectedDuration}
              defaultValue={() => {
                return durationOptions[0].value;
              }}
              dropdownColor="#FFFFFF"
              onChange={handleDurationChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Type"
              options={selectOptionsExamType}
              value={selectedExamType}
              defaultValue={() => {
                return examTypeOptions[0].value;
              }}
              dropdownColor="#FFFFFF"
              onChange={handleExamTypeChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectValueBatch1}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Cycle"
              options={selectValueExamCycle1}
              value={selectValueExamCycle}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeExamCycle}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>
      {/* Message Modal */}
      <KenDialogBox
        open={retestExamDialog}
        handleClose={() => handleRetestExamDialog()}
        // negativeButtonClick={() => handleSendBulkMessageDialogNo()}
        // positiveButtonClick={() => handleSendBulkMessageDialogYes()}
        // positiveButtonText="Yes"
        // negativeButtonText="No"
        hidePositiveButton={true}
        hideNegativeButton={true}
        // dividers
      >
        <RetestExam
          retestExamDialog={retestExamDialog}
          setRetestExamDialog={setRetestExamDialog}
        />
      </KenDialogBox>
    </Box>
  );
};

export default SeatingPlan;
